export enum ComponentTypes {
  QUESTION = 'question',
  STORE_SECTION = 'storeSection',
  NEW_STORE_SECTION = 'newStoreSection',
  SOCIAL = 'social',
  PLAN = 'plan',
  PRODUCT = 'product',
  BULLET_LIST = 'bullet-list',
  CUSTOM_BUTTON = 'customButton',
  LAUNCHER_SELECT = 'launcher_select',
  PLATFORM_REQ = 'platform_req',
  SLIDE = 'slide',
  PROMO_SLIDE = 'promoSlide',
  PACK = 'pack',
  RETAILERS = 'retailers',
  // Description
  IMAGE = 'image',
  TEXT = 'text',
  // Social widget block
  TWITTER_FEED = 'twitter_feed',
  DISCORD_EMBED = 'discord_embed',
  FACEBOOK_FEED = 'facebook_feed',
  TWITCH_EMBED = 'twitch_embed',
  // Footer block
  AGE_RESTRICTION = 'ageRestriction',
  PEGI = 'pegi',
  ESRB = 'esrb',
  USK = 'usk',
  CLASSIND = 'classind',
  ACB = 'acb',
  OFLC = 'oflc',
  IARC = 'iarc',
}

export enum SubComponentTypes {
  BULLET_LIST_ITEM = 'bullet-list-item',
  CUSTOM_SELECTOR = 'custom-selector',
  RETAILERS_BUTTON = 'retailersButton',
}
